import { Box, IconButton, Typography } from "@mui/material";
import { FC } from "react";
import CrossIcon from "../../../../assets/icons/cross-icon";

interface OrderCartItemProcessTypeProps {
    label: string;
    onRemove: () => void;
}

const OrderCartItemProcessType: FC<OrderCartItemProcessTypeProps> = ({
    label,
    onRemove,
}) => {
    return (
        <Box sx={{ display: "flex", alignItems: "center", mt: 1 }}>
            <Box>
                <Typography>+ </Typography>
            </Box>
            <Typography>{label}</Typography>
            <IconButton
                onClick={(e) => {
                    e.stopPropagation();
                    onRemove();
                }}
                sx={{ ml: 1 }}
            >
                <CrossIcon />
            </IconButton>
        </Box>
    );
};

export default OrderCartItemProcessType;
